import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IDownloadStrategy} from '@igp/shared/redux/download';
import type {IEntityReadService} from '@igp/shared/redux/entity';
import type {EntityType} from '@models';

import {PayoutReportServiceTypes} from './constants';
import {PayoutReportDownloadClientStrategy, PayoutReportDownloadServerStrategy} from './downloadStrategy';
import {PayoutReportService} from './service';
import type {PayoutReportViewModelKeys} from './types';

export class PayoutReportContainerFacade extends ContainerFacade {
    bindAll() {
        this._container.bind<IEntityReadService<EntityType>>(PayoutReportServiceTypes.service).to(PayoutReportService);
        this._container
            .bind<IDownloadStrategy<PayoutReportViewModelKeys>>(PayoutReportServiceTypes.downloadClientStrategy)
            .to(PayoutReportDownloadClientStrategy);
        this._container
            .bind<IDownloadStrategy<PayoutReportViewModelKeys>>(PayoutReportServiceTypes.downloadServerStrategy)
            .to(PayoutReportDownloadServerStrategy);
    }
}
